module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-blue.b3109f82.svg";